/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import { featureFlagClient } from '@trello/feature-flag-client';

import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('list_menu');

// eslint-disable-next-line @trello/no-module-logic
export const ListMenuTemplate = t.renderable(function ({
  editable,
  subscribed,
  canCopyList,
  hasSortableCards,
  pluginActions,
  listLimitsEnabled,
  isEmbeddedInAtlassian,
  isTemplate,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  t.ul('.pop-over-list', function () {
    if (editable) {
      t.li(() =>
        t.a('.js-add-card', { href: '#' }, () => t.format('add-card-ellipsis')),
      );
      if (canCopyList) {
        t.li(() =>
          t.a('.js-copy-list', { href: '#' }, () =>
            t.format('copy-list-ellipsis'),
          ),
        );
      }
      t.li(() =>
        t.a('.js-move-list', { href: '#' }, () =>
          t.format('move-list-ellipsis'),
        ),
      );

      if (featureFlagClient.get('workflowers.list-colors', false)) {
        t.li(() =>
          t.a('.js-open-list-status-picker', { href: '#' }, () =>
            // TODO: Localize this once we have copy!
            t.text('Set list status'),
          ),
        );
      }
    }

    if (!isTemplate) {
      const watchExperimentVariant = featureFlagClient.getTrackedVariation(
        'teamplates.web.terminology-watch-experiment',
        'not-enrolled',
      );

      const enrolledInWatchExperiment =
        // @ts-expect-error TS(2367): This condition will always return 'false' since th... Remove this comment to see the full error message
        watchExperimentVariant === 'experiment-v1' ||
        // @ts-expect-error TS(2367): This condition will always return 'false' since th... Remove this comment to see the full error message
        watchExperimentVariant === 'experiment-v2';

      return t.li(() =>
        t.a('.highlight-icon.js-list-subscribe', { href: '#' }, () =>
          t.check(subscribed, enrolledInWatchExperiment ? 'follow' : 'watch'),
        ),
      );
    }
  });

  if (editable) {
    if (hasSortableCards) {
      t.hr();
      t.ul('.pop-over-list', () =>
        t.li(() =>
          t.a('.js-sort-cards', { href: '#' }, () => t.format('sort-by')),
        ),
      );
    }
    if (!isEmbeddedInAtlassian) {
      t.div('.js-list-menu-butler-section');
    }

    if ((pluginActions != null ? pluginActions.length : undefined) > 0) {
      t.hr();

      t.ul('.pop-over-list', () =>
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        pluginActions.map((action: any, index: any) =>
          t.li(function () {
            if (_.isFunction(action.callback)) {
              return t.a(
                '.plugin-list-action.js-plugin-list-action',
                { href: '#', 'data-index': index, title: action.text },
                function () {
                  t.span(() => t.text(action.text));
                  return t.img({
                    src: action.icon,
                    title: action.name,
                    height: '18px',
                    width: '18px',
                  });
                },
              );
            }
          }),
        ),
      );
    }

    if (listLimitsEnabled) {
      t.hr();
      t.ul('.pop-over-list', () =>
        t.li(() =>
          t.a('.js-set-list-limit', { href: '#' }, () =>
            t.format('set-list-limit'),
          ),
        ),
      );
    }

    t.hr();

    t.ul('.pop-over-list', function () {
      t.li(() =>
        t.a('.js-move-cards', { href: '#' }, () =>
          t.format('move-all-cards-in-this-list-ellipsis'),
        ),
      );
      return t.li(() =>
        t.a('.js-archive-cards', { href: '#' }, () =>
          t.format('archive-all-cards-in-this-list-ellipsis'),
        ),
      );
    });

    t.hr();

    return t.ul('.pop-over-list', () =>
      t.li(() =>
        t.a('.js-close-list', { href: '#' }, () =>
          t.format('archive-this-list'),
        ),
      ),
    );
  }
});
